import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import { NotificationsNone, Language, Settings } from "@material-ui/icons";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AddCardIcon from "@mui/icons-material/AddCard";
import AddIcon from "@mui/icons-material/Add";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Tooltip from "@mui/material/Tooltip";

import "./topbar.css";
import ConnectWalletButton from "../web3/ConnectWalletButton";
import { toastExpiredWallets } from "../common/toasts";
import TopupDlg from "../crudSql/topupDlg/TopupDlg";

export default function Topbar(props) {
  // console.log("Topbar", props, props.smUserBalanceUsd);

  // const { pathName } = useLocation();
  const location = useLocation();

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (props.userAuthWallet != "") {
      toastExpiredWallets(props.userWallets, props.userAuthWallet);
    }
    // }, [props.userWallets, pathName]);
  }, [props.userWallets, location]);

  return (
    <>
      <div className="topbar">
        <div className="topbarWrapper">
          <div className="topLeft">
            <Link to="/" className="link">
              <span className="logo">
                {/* <label>dw</label> */}
                {/* <img className="logoImg" src="/img/logo/fox-shield-transp.png" />
              DefiWatch.biz */}
                <img className="logoImg" src="/img/logo/logoTranspTxt.png" />
                <img className="logoTxt" src="/img/logo/DefiWatch2.png" />
              </span>
            </Link>
            <label className="slogan">Actual DeFi Performance</label>
          </div>

          {/* <div className="topRight">
                    <div className="topbarIconContainer">
                        <NotificationsNone/>
                        <span className="topIconBadge">2</span>
                    </div>
                    <div className="topbarIconContainer">
                        <Language/>
                        <span className="topIconBadge">2</span>
                    </div>
                    <div className="topbarIconContainer">
                        <Settings/>
                    </div>
                    <img src="/images/Mountain.jpg" alt="" className="topAvatar" />
                </div> */}
          <div className="topRight">
            <span className="balance">
              <Tooltip title="Top up your balance">
                <img
                  src="/img/ico/topup.png"
                  width="22"
                  height="20"
                  // title="Top up your balance"
                  className="btnTopup"
                  onClick={
                    props.userAuthWallet
                      ? handleClickOpen
                      : () =>
                          toast.error("Please connect to Metamask!", {
                            autoClose: 3000,
                          }) //undefined
                  }
                />
              </Tooltip>
              {/* <img src={topupImg} width="20" /> */}
              <AttachMoneyIcon fontSize="small" />
              {props.smUserBalanceUsd}
              <b className="dw">dw</b> {props.smUserBalanceDw}
              {/* <AddIcon fontSize="small" /> */}
            </span>

            <ConnectWalletButton />
          </div>
        </div>
        {props.newWallets.length > 0 && (
          <div className="topNotification">
            A new wallet
            {" " + props.newWallets[0] + " "}
            has been added. It will be indexed within 30 minutes.
          </div>
        )}
      </div>

      <TopupDlg
        // getAlerts={getAlerts}
        // trackedParametersA={trackedParametersA}
        userAuthWallet={props.userAuthWallet}
        open={open}
        setOpen={setOpen}
      />
    </>
  );
}
